import { formatHtml } from "@trumpf/ux.common-storybook";
import { getIframePageDecorators } from "../../../shared/page";
import { BusinessYearTemplate } from "./business-year.templates";

export default {
    title: "Website/Partial Templates/Newsroom Blocks/Business Year Block (C.25)",
    render: BusinessYearTemplate.bind({}),
    decorators: getIframePageDecorators(),
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
    args: {
        title: "Highlight Topic Lorem ipsum Dolor",
        icon: "globe",
        ctaText: "Mehr erfahren",
        ctaLink: "#",
    },
};

export const Default = {};
